import React, {RefObject, useEffect, useRef} from "react";
import {Stage} from "react-konva";
import {useResizeObserver} from "usehooks-ts";
import Konva from "konva";
import {useStage} from "@/components/konva/stage/ResponsiveStageHooks.ts";
import {ResponsiveStageProvider} from "@/components/konva/stage/ResponsiveStageProvider.tsx";

export default function ResponsiveStage({children}: { children: React.ReactNode }) {

    useEffect(() => {
        Konva.dragButtons = [0, 2, 4];
    })

    return (
        <ResponsiveStageProvider>
            <InnerStage>
                {children}
            </InnerStage>
        </ResponsiveStageProvider>
    )
}

function InnerStage({children}: { children: React.ReactNode }) {
    const {stageRef, stageSize, setStageSize} = useStage();
    const resizeRef = useRef<HTMLDivElement>(null);

    const onResize = (size: { width: number | undefined, height?: number | undefined }) => {
        const {width, height} = size;
        if (width === undefined || height === undefined || width <= 0 || height <= 0) return;

        setStageSize({width, height});
    };

    useResizeObserver({ref: resizeRef as RefObject<HTMLDivElement>, onResize, box: "content-box"});

    return (
        <div ref={resizeRef} className="w-full h-full relative">
            <Stage className="absolute" width={stageSize.width} height={stageSize.height} ref={stageRef}>
                {children}
            </Stage>
        </div>
    )

}
